var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormLayoutSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.7003H8.69835V0.00195312H0V8.7003ZM1.37828 1.37978H7.32098V7.32248H1.37828V1.37978Z",
    fill: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0002H8.69835V10.3027H0V19.0002ZM1.37828 11.6806H7.32098V17.6214H1.37828V11.6806Z",
    fill: "#CD2A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 19H18.6018V0H9.90479V19ZM11.2822 1.37919H17.2239V17.6231H11.2826V1.37919H11.2822Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLayoutSwitch);
export default __webpack_public_path__ + "static/media/formLayoutSwitch.99e0ca8656acf0786a8c3e1c93b7b03b.svg";
export { ForwardRef as ReactComponent };